export default __webpack_public_path__ + "static/launchdarkly-tablet-8ef8cf59fdf027abf7661ecc5d5c5c7f.jpg";